import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Web3ModalProvider } from './contexts/WagmiContext';
import ErrorBoundary from './pages/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ErrorBoundary>
      <Web3ModalProvider>
        <App />
      </Web3ModalProvider>
    </ErrorBoundary>
  </BrowserRouter>
);

reportWebVitals();
